module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-down-square-f6ec59e9.svg";